import type { MessagingChannelsCopy } from './types';

export const ES: MessagingChannelsCopy = {
  title: 'Mensajería',
  description:
    'Habla con IMAI desde las apps de chat que ya usas. Conéctate una vez y escríbele a IMAI ahí.',
  privacy:
    'Los mensajes de tus cuentas conectadas se ejecutan en tu nombre en este espacio de trabajo y usan tus créditos.',
  loading: 'Cargando canales de mensajería',
  unavailable: 'Aún no disponible',
  unavailableNote: '{channel} todavía no está configurado para IMAI.',
  connectedBadge: 'Conectado',
  cancel: 'Cancelar',

  phoneTitle: 'Número de teléfono',
  phoneNote: 'Conecta WhatsApp o iMessage con tu número de teléfono.',
  phoneUnavailableNote:
    'Los mensajes de texto con IMAI aún no están configurados.',
  addNumber: 'Agregar número',
  countryLabel: 'Código de país',
  countrySearch: 'Buscar país o código…',
  countryEmpty: 'No se encontraron países.',
  numberLabel: 'Número de teléfono',
  numberPlaceholder: 'Número de teléfono',
  numberHint:
    '¿Tu país no aparece? Escribe el número completo empezando con +.',
  continueActivation: 'Continuar',
  editNumber: 'Cambiar número',
  activateQr: 'Escanea y envía para conectar.',
  activateTitle: 'Envía un mensaje por WhatsApp',
  activateHint: 'Toca el botón y envía el mensaje que ya está escrito.',
  activateSentFrom: 'Envíalo desde {number}.',
  activateButton: 'Abrir {channel}',
  activateManual: 'O envía {message} a {number} por WhatsApp.',
  activateWaiting: 'Esperando tu mensaje. Vence en {time}.',
  startAgain: 'Empezar de nuevo',
  verifiedBadge: 'Verificado',
  verifiedOn: 'Verificado el {date}',
  change: 'Cambiar',
  changeAria: 'Cambiar el número {number}',
  remove: 'Quitar',
  removeAria: 'Quitar el número {number}',
  messageImai: 'Escribir a IMAI',
  messageImaiAria: 'Escribir a IMAI por {channel}',
  removeTitle: '¿Quitar {number}?',
  removeDescription:
    'IMAI dejará de responder a este número en iMessage y WhatsApp. Puedes volver a agregarlo cuando quieras.',
  removeError: 'No se pudo quitar el número. Inténtalo de nuevo.',

  errorInvalidNumber: 'Ingresa un número válido, con el código de área.',
  errorNumberTaken: 'Este número ya lo usa otra cuenta de IMAI.',
  errorRateLimited:
    'Demasiados intentos. Espera un rato y vuelve a intentarlo.',
  errorChannelUnavailable:
    'Esa opción no está disponible ahora. Elige la otra.',
  errorSendFailed: 'No se pudo iniciar la verificación. Inténtalo de nuevo.',
  errorActivationExpired: 'Esta activación venció. Empieza de nuevo.',

  noteSlack: 'Escríbele a IMAI desde tu espacio de trabajo de Slack.',
  noteTeams: 'Escríbele a IMAI desde Microsoft Teams.',
  noteTelegram: 'Chatea con el bot de IMAI en Telegram.',
  connect: 'Conectar',
  connectAria: 'Conectar {channel}',
  connectError: 'No se pudo empezar a conectar {channel}. Inténtalo de nuevo.',
  connectedOn: 'Conectado el {date}',
  accountFallback: 'Tu cuenta de {channel}',
  installSlack: 'Agregar IMAI a tu espacio de trabajo',
  installTeams: 'Agregar IMAI a Teams',
  openTelegram: 'Abrir en Telegram',
  disconnect: 'Desconectar',
  disconnectAria: 'Desconectar {account} de {channel}',
  disconnectError: 'No se pudo desconectar {channel}. Inténtalo de nuevo.',
  disconnectTitle: '¿Desconectar {channel}?',
  disconnectDescription:
    'Los mensajes de {account} dejarán de llegar a IMAI. Puedes volver a conectarla cuando quieras.',

  toastConnected: '{channel} conectado',
  toastConnectedGeneric: 'Cuenta conectada',
  toastErrorExpired:
    'El inicio de sesión tardó demasiado. Vuelve a intentar conectarte.',
  toastErrorInvalidState:
    'Ese enlace de inicio de sesión ya no es válido. Vuelve a intentarlo.',
  toastErrorAccountTaken:
    'Esa cuenta ya está conectada a otro usuario de IMAI.',
  toastErrorNotMember: 'Ya no eres miembro de este espacio de trabajo.',
  toastErrorProvider:
    'El inicio de sesión no terminó. Vuelve a intentar conectarte.',
  toastErrorGeneric: 'No se pudo conectar la cuenta. Inténtalo de nuevo.',
};
